import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.workspace.header');
import { Input, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-workspace-header',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.workspace.header/view.scss */
:host {
  display: block;
  min-width: 0;
  width: calc(100% + var(--workbench-collapsed-inset, 0px));
  margin-left: calc(0px - var(--workbench-collapsed-inset, 0px));
  position: sticky;
  top: 0;
  z-index: 20;
  container-type: inline-size;
}

.workspace-header-agent {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 11px;
  border: 1px solid #bfd5f8;
  border-radius: 9px;
  background: #f3f7ff;
  color: #1260ce;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}
.workspace-header-agent:hover {
  background: #e7f0ff;
}
.workspace-header-agent:focus-visible {
  outline: 2px solid #1765e7;
  outline-offset: 2px;
}

.workspace-header {
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.workspace-header-inner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: var(--workspace-header-max-width, 1600px);
  min-height: 66px;
  margin: 0 auto;
  padding: 12px 28px;
}

.workspace-header.has-center .workspace-header-inner {
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
}

.workspace-header-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.workspace-header-icon {
  display: grid;
  flex: 0 0 36px;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: #eff6ff;
  color: #1d63db;
  font-size: 17px;
}

.workspace-header-copy {
  min-width: 0;
}

.workspace-header-copy h1 {
  overflow: hidden;
  margin: 0;
  color: #0f172a;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workspace-header-copy p {
  overflow: hidden;
  margin: 3px 0 0;
  color: #64748b;
  font-size: 11px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.workspace-header-center.is-empty {
  display: none;
}

.workspace-header-center {
  align-self: stretch;
  min-width: 0;
}

.workspace-header-meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  min-width: 0;
  color: #64748b;
  font-size: 12px;
  white-space: nowrap;
}

.workspace-header-meta time,
.workspace-header-user {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.workspace-header-user {
  min-height: 28px;
  padding-left: 16px;
  border-left: 1px solid #dbe5f2;
  color: #284676;
  font-weight: 700;
}

.workspace-header-user > i {
  display: grid;
  flex: 0 0 28px;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #eaf2ff;
  font-size: 13px;
}

@media (max-width: 1200px) {
  .workspace-header.has-center .workspace-header-inner {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .workspace-header.has-center .workspace-header-center {
    grid-column: 1/-1;
    grid-row: 2;
    justify-self: center;
  }
}
/* The agent narrows the content pane without changing the viewport width. */
@container (max-width: 900px) {
  .workspace-header.has-center .workspace-header-inner {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .workspace-header.has-center .workspace-header-center {
    grid-column: 1/-1;
    grid-row: 2;
    justify-self: center;
  }
}
@container (max-width: 700px) {
  .workspace-header-inner,
  .workspace-header.has-center .workspace-header-inner {
    grid-template-columns: minmax(0, 1fr);
    gap: 9px;
    padding: 10px 18px;
  }
  .workspace-header-meta {
    grid-row: 2;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 8px 16px;
    font-size: 11px;
  }
  .workspace-header.has-center .workspace-header-center {
    grid-column: 1;
    grid-row: 3;
    justify-self: stretch;
  }
}
@media (max-width: 720px) {
  .workspace-header-inner {
    grid-template-columns: minmax(0, 1fr);
    gap: 9px;
    padding: 10px 18px;
  }
  .workspace-header.has-center .workspace-header-inner {
    grid-template-columns: minmax(0, 1fr);
  }
  .workspace-header-meta {
    grid-row: 2;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 8px 16px;
    font-size: 11px;
  }
  .workspace-header.has-center .workspace-header-center {
    grid-column: 1;
    grid-row: 3;
    justify-self: stretch;
  }
  .workspace-header-user {
    padding-left: 12px;
  }
}`],
})
export class ComponentWorkspaceHeaderComponent implements OnInit, OnDestroy {
    @Input() heading: string = '';
    @Input() description: string = '';
    @Input() icon: string = 'fa-regular fa-image';
    @Input() hasCenter: boolean = false;

    public todayLabel: string = '';
    public todayIso: string = '';
    private dateTimer: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public agentAvailable() {
        return ['/content', '/references', '/scenario-sets', '/prompts', '/schedule', '/members', '/ai/usage']
            .includes(window.location.pathname);
    }

    public openAgent() {
        window.dispatchEvent(new CustomEvent('ptsd:agent:open'));
    }

    public ngOnInit() {
        this.refreshDate();
        this.dateTimer = window.setInterval(() => this.refreshDate(), 60000);
    }

    public ngOnDestroy() {
        if (this.dateTimer) window.clearInterval(this.dateTimer);
        this.dateTimer = null;
    }

    private refreshDate() {
        const parts = new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            weekday: 'short'
        }).formatToParts(new Date());
        const part = (type: string) => parts.find((item: any) => item.type === type)?.value || '';
        this.todayIso = `${part('year')}-${part('month')}-${part('day')}`;
        this.todayLabel = `${part('year')}. ${part('month')}. ${part('day')}. (${part('weekday')})`;
    }
}

export default ComponentWorkspaceHeaderComponent;